import { graphql, useStaticQuery } from 'gatsby';

export type UseFooter = {
  footer: Queries.ContentfulFooter001;
};

const useFooter = (): UseFooter => {
  const { allContentfulFooter001 } = useStaticQuery(graphql`
    query FooterQuery {
      allContentfulFooter001(
        filter: { contentfulid: { eq: "main-footer" } }
        limit: 1
      ) {
        nodes {
          mainNavigation {
            groupLabel
            menuLinks {
              url
              label
            }
          }
          newsletterLabel
          disclaimer {
            childMarkdownRemark {
              html
            }
          }
          policyLinks {
            url
            label
          }
          socialMediaLabel
          listOfSocialMedia {
            name
            link {
              url
              label
            }
          }
        }
      }
    }
  `);

  return {
    footer: allContentfulFooter001.nodes[0],
  };
};

export default useFooter;
